import { FunctionComponent } from 'react';
import { SIRemovedAccount } from 'widgets/auth/signIn/RemovedAccount';

export const RemovedAccount: FunctionComponent = () => {
	return <SIRemovedAccount />;
};
